(function () {

  'use strict';

  /**
   * @author Ronald Nicholls
   * @description changes capacity to MB or GB
   * @class ute-ui
   * @memberOf ute-ui
   */
  angular.module('ute.ui')

    .filter('uteCapacityUnit', ["$filter", function ($filter) {

      return function (capacity) {

        var translationMB = $filter('translate')('global.unit.mb'),
          translationGB = $filter('translate')('global.unit.gb');

        if (capacity >= 1000) {
          return translationGB;
        } else {
          return translationMB;
        }

      };

    }])

    .filter('uteCapacity', ["$rootScope", "uteLocale", "$filter", function ($rootScope, uteLocale, $filter) {

      return function (capacity, showDecimals, showUnit) {

        if (typeof showDecimals === 'undefined') showDecimals = true;
        if (typeof showUnit === 'undefined') showUnit = true;

        var translationMB = $filter('translate')('global.unit.mb'),
          translationGB = $filter('translate')('global.unit.gb'),
          calculateCapacity = function () {
            if (capacity >= 1000) {
              if (showDecimals === false) {
                return (Math.round(Number(capacity) / 1024)) + ' ' + (showUnit ? ' ' + translationGB : '');
              } else {
                return (Math.round((Number(capacity) / 1024) * 100) / 100) + ' ' + (showUnit ? ' ' + translationGB : '');
              }
            } else {
              return capacity + (showUnit ? ' ' + translationMB : '');
            }
          };

        return calculateCapacity();

      };

    }]);

})();